import React from "react";
import axios from "axios";
import {API_URL, baseEventUrl} from "../config";
import authHeader from "./auth-header";
import {orderBy, remove} from "lodash";

export const forms = {
    CHECKIN: {id: "checkin", label: "Check-in", position: 100, timelineField: 'checkedInAt', precisionMinute: true, description: 'Struttura che consente di monitorare l\'accesso all\'evento'},
    ARCHIVED: {id: "archived", label: "", position: 101, timelineField: 'updatedAt', precisionMinute: false, description: 'Utenti archiviati'},
}

const settingsUrl = (event_id) => {
    return `${baseEventUrl(event_id)}config/settings`
}

const getSettings = (event_id) => {
    return axios.get(settingsUrl(event_id), { headers: authHeader() })
};

const saveSettings = (event_id, settings) => {
    return axios.post(settingsUrl(event_id), {...settings}, {headers: authHeader()})
};

const getForms = (settings, dataStructures) => {
    const _data = Object.values(dataStructures)
    const res = orderBy(_data, 'position')
    if(!settings?.checkin) {
        remove(res, ['id', forms.CHECKIN.id])
    } else {
        dataStructures[forms.CHECKIN.id] = {
            ...dataStructures[forms.CHECKIN.id],
            position: _data.length -1
        }
    }
    return res
};

const SettingsService = {
    settingsUrl,
    getSettings,
    saveSettings,
    getForms
};

export default SettingsService;